import * as React from "react";
function SvgSnapshotConfirmation(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg viewBox="0 0 369 328" ref={svgRef} {...props}>
      <defs>
        <style>
          {
            ".snapshot-confirmation_svg__cls-1{fill:#f3f5f9}.snapshot-confirmation_svg__cls-10,.snapshot-confirmation_svg__cls-3,.snapshot-confirmation_svg__cls-4,.snapshot-confirmation_svg__cls-5,.snapshot-confirmation_svg__cls-7,.snapshot-confirmation_svg__cls-8,.snapshot-confirmation_svg__cls-9{fill:none;stroke-width:2px}.snapshot-confirmation_svg__cls-3{stroke:#00a9a1}.snapshot-confirmation_svg__cls-3,.snapshot-confirmation_svg__cls-4,.snapshot-confirmation_svg__cls-5{stroke-linecap:round;stroke-linejoin:round}.snapshot-confirmation_svg__cls-4,.snapshot-confirmation_svg__cls-7{stroke:#2a98c4}.snapshot-confirmation_svg__cls-5{stroke:#d44090}.snapshot-confirmation_svg__cls-6{fill:#a2a7b8}.snapshot-confirmation_svg__cls-10,.snapshot-confirmation_svg__cls-7,.snapshot-confirmation_svg__cls-8,.snapshot-confirmation_svg__cls-9{stroke-miterlimit:10}.snapshot-confirmation_svg__cls-8{stroke:#ffd300}.snapshot-confirmation_svg__cls-9{stroke:#37938b}.snapshot-confirmation_svg__cls-10{stroke:#ab5684}"
          }
        </style>
      </defs>
      <path className="snapshot-confirmation_svg__cls-1" d="M0 0h369v328H0z" />
      <path
        d="M77.14 36h214.72a5 5 0 015 5v287.09H72.14V41a5 5 0 015-5z"
        fill="#fff"
      />
      <path
        className="snapshot-confirmation_svg__cls-1"
        d="M94.36 105.89h56.18v44.94H94.36zM156.41 105.89h56.18v44.94h-56.18zM94.61 155.23h179.77v44.94H94.61zM94.61 57.81h179.77v43.21H94.61zM217.95 105.89h56.18v44.94h-56.18zM94.36 204.8h56.18v56.18H94.36z"
      />
      <path
        className="snapshot-confirmation_svg__cls-3"
        d="M98 137.34l13.15-7.86 11.3 7.86 24.45-17.97"
      />
      <path
        className="snapshot-confirmation_svg__cls-4"
        d="M160.05 137.34l13.15-7.86 11.3 7.86 24.45-17.97"
      />
      <path
        className="snapshot-confirmation_svg__cls-5"
        d="M221.6 137.34l13.14-7.86 11.3 7.86 24.45-17.97"
      />
      <path
        className="snapshot-confirmation_svg__cls-1"
        d="M94.36 266.7h56.18v44.94H94.36zM156.41 266.7h56.18v44.94h-56.18zM217.95 266.7h56.18v44.94h-56.18z"
      />
      <path
        className="snapshot-confirmation_svg__cls-3"
        d="M98 298.16l13.15-7.87 11.3 7.87 24.45-17.98"
      />
      <path
        className="snapshot-confirmation_svg__cls-4"
        d="M160.05 298.16l13.15-7.87 11.3 7.87 24.45-17.98"
      />
      <path
        className="snapshot-confirmation_svg__cls-5"
        d="M221.6 298.16l13.14-7.87 11.3 7.87 24.45-17.98"
      />
      <path
        className="snapshot-confirmation_svg__cls-1"
        d="M156.18 204.8h56.18v56.18h-56.18zM217.56 204.85h56.18v56.18h-56.18z"
      />
      <path
        className="snapshot-confirmation_svg__cls-6"
        d="M100.12 159.72h15.36v15.73h-15.36zM119.29 159.72h15.36v15.73h-15.36zM138.47 159.72h15.36v15.73h-15.36zM157.64 159.72H173v15.73h-15.36zM176.82 159.72h15.36v15.73h-15.36zM196 159.72h15.36v15.73H196zM215.17 159.72h15.36v15.73h-15.36zM234.35 159.72h15.36v15.73h-15.36zM253.52 159.72h15.36v15.73h-15.36zM100.12 179.95h15.36v15.73h-15.36zM119.29 179.95h15.36v15.73h-15.36zM138.47 179.95h15.36v15.73h-15.36zM157.64 179.95H173v15.73h-15.36zM176.82 179.95h15.36v15.73h-15.36zM196 179.95h15.36v15.73H196zM215.17 179.95h15.36v15.73h-15.36zM234.35 179.95h15.36v15.73h-15.36zM253.52 179.95h15.36v15.73h-15.36zM99.11 80.88h170.78v5H99.11zM99.11 72.45h170.78v4H99.11zM99.11 64.53h170.78v4H99.11zM99.11 90.3H245v4H99.11z"
      />
      <path
        className="snapshot-confirmation_svg__cls-7"
        d="M257.27 224.12a14.57 14.57 0 00-22.16-1.29"
      />
      <path
        className="snapshot-confirmation_svg__cls-8"
        d="M260.23 233.42v-.49a14.53 14.53 0 00-3-8.81M256.11 243.11a14.54 14.54 0 004.12-9.69"
      />
      <path
        className="snapshot-confirmation_svg__cls-7"
        d="M235.11 222.83a14.57 14.57 0 00-4 9.43"
      />
      <path
        className="snapshot-confirmation_svg__cls-8"
        d="M234.46 242.32a14.58 14.58 0 0021.65.79"
      />
      <path
        className="snapshot-confirmation_svg__cls-7"
        d="M231.07 232.26v.67a14.56 14.56 0 003.42 9.39M195.9 224.08a14.57 14.57 0 00-22.16-1.29"
      />
      <path
        className="snapshot-confirmation_svg__cls-9"
        d="M198.86 233.37v-.48a14.53 14.53 0 00-3-8.81M194.74 243.07a14.6 14.6 0 004.12-9.7"
      />
      <path
        className="snapshot-confirmation_svg__cls-7"
        d="M173.74 222.79a14.55 14.55 0 00-4 9.43"
      />
      <path
        className="snapshot-confirmation_svg__cls-10"
        d="M173.09 242.28a14.58 14.58 0 0021.65.79"
      />
      <path
        className="snapshot-confirmation_svg__cls-7"
        d="M169.7 232.22v.67a14.56 14.56 0 003.42 9.39M113.64 221.26a14.55 14.55 0 00-1.29 22.16"
      />
      <path
        className="snapshot-confirmation_svg__cls-9"
        d="M122.93 218.31h-.48a14.52 14.52 0 00-8.81 3M132.63 222.43a14.52 14.52 0 00-9.7-4.12"
      />
      <path
        className="snapshot-confirmation_svg__cls-8"
        d="M112.35 243.42a14.45 14.45 0 009.43 4"
      />
      <path
        className="snapshot-confirmation_svg__cls-10"
        d="M131.84 244.08a14.58 14.58 0 00.79-21.65"
      />
      <path
        className="snapshot-confirmation_svg__cls-7"
        d="M121.78 247.46h.67a14.56 14.56 0 009.39-3.42"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSnapshotConfirmation);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
